import {differenceInHours} from 'date-fns';
import localeKz from 'date-fns/locale/kk';
import localeRu from 'date-fns/locale/ru';
import {format, utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';

import {TIME_ZONE_ALMATY} from '../../../constants/date';

const DURATION_MATCH_IN_HOURS = 2;
const LANGUAGE_LOCALES = {
  www: localeRu,
  kaz: localeKz
};

const formatDateTimeToUtc = date => utcToZonedTime(zonedTimeToUtc(date), TIME_ZONE_ALMATY);

export const formattedDate = (date, locale = localeRu, dateFormat = 'd MMMM, kk:mm') => format(
  formatDateTimeToUtc(date),
  dateFormat,
  {locale, timeZone: TIME_ZONE_ALMATY}
);

export const getMatchDate = (date, language) => formattedDate(
  date,
  LANGUAGE_LOCALES[language],
  'd MMM, kk:mm'
)
  .replace('.', '');

export const isDisplayScore = (date, leftScore, rightScore) => {
  if (leftScore === null || rightScore === null) {
    return false;
  }
  const differenceInHoursMatch = differenceInHours(new Date(), zonedTimeToUtc(date));

  return differenceInHoursMatch >= DURATION_MATCH_IN_HOURS;
};
